import { defineStore } from 'pinia'
import { ref } from 'vue'
import { SelectionsApi, type Selection, type Selections } from '@/api-swagger'
import { withApiState } from '@/utils/withApiState'

export const useSelectionsStore = defineStore('selections', () => {
  const statusCallSessionsSelections = ref<Selection[]>([])
  const stateCampaignSelections = ref<Selection[]>([])
  const salesFamilyOpportunitySelections = ref<Selection[]>([])
  const typeOfSaleOpportunitySelections = ref<Selection[]>([])
  const currentStatusPartnerSelections = ref<Selection[]>([])
  const loading = ref(false)
  const api = new SelectionsApi()

  const getAll = async () => {
    await withApiState(
      async () => {
        const selections: Selections[] = await api.getAllSelections()
        for (const selection of selections) {
          // Match by field name: BoostConnectors uses JSON-RPC (often en_US) so ir.model.name is
          // e.g. "Lead/Opportunity" instead of legacy REST + session cookie "Piste/Opportunité".
          if (selection.name === 'sales_family') {
            salesFamilyOpportunitySelections.value = selection.selectionIds
            continue
          }
          if (selection.name === 'type_of_sale') {
            typeOfSaleOpportunitySelections.value = selection.selectionIds
            continue
          }
          if (selection.name === 'current_status') {
            currentStatusPartnerSelections.value = selection.selectionIds
            continue
          }
          switch (selection.modelId.name) {
            case 'boost.campaign':
              stateCampaignSelections.value = selection.selectionIds
              break
            case 'boost.call.session':
              statusCallSessionsSelections.value = selection.selectionIds
              break
            case 'Contact':
              currentStatusPartnerSelections.value = selection.selectionIds
              break
          }
        }
      },
      { loading },
    )
  }

  return {
    statusCallSessionsSelections,
    stateCampaignSelections,
    salesFamilyOpportunitySelections,
    typeOfSaleOpportunitySelections,
    currentStatusPartnerSelections,
    loading,
    getAll,
  }
})
